import {
  APPROACH,
  NEEDLE_GAUGE,
  number,
  OTHER_TEXT,
  option,
  PRESENT_ABSENT_NOT_ASSESSED,
  type ProcedureDefinition,
  routine,
  SHARED_FIELD_IDS,
  SHARED_FIELDS,
  single,
  text,
  YES_NO,
  YES_PARTIAL_NO,
} from "./procedure-fields";

const GUIDANCE = "76942";

export const GUIDED_TENDON_INJECTION: ProcedureDefinition = {
  examType: "guided_tendon_injection",
  version: 1,
  allNormal: true,
  indications: [
    option("trigger_finger", "Trigger finger"),
    option("de_quervain", "De Quervain's tenosynovitis"),
    option("other_tenosynovitis", "Other tenosynovitis"),
    option("carpal_tunnel_syndrome", "Carpal tunnel syndrome"),
    option("plantar_fasciitis", "Plantar fasciitis"),
    option(
      "tendon_origin_insertion",
      "Tendon origin / insertion (e.g. lateral epicondylitis)",
    ),
    option("other", "Other"),
  ],
  views: [
    option("pre_target_longitudinal", "Pre-procedure target, longitudinal"),
    option("pre_target_transverse", "Pre-procedure target, transverse"),
    option("doppler", "Doppler"),
    option("needle_in_target_in_plane", "Needle-in-target, in-plane"),
    option("needle_in_target_out_of_plane", "Needle-in-target, out-of-plane"),
    option("post_procedure", "Post-procedure"),
  ],
  fields: [
    ...SHARED_FIELDS,
    single("site", "Site", [
      option("flexor_tendon_sheath", "Flexor tendon sheath (digit in notes)"),
      option("first_extensor_compartment", "1st extensor compartment"),
      option("other_tendon_sheath", "Other tendon sheath", true),
      option("carpal_tunnel", "Carpal tunnel"),
      option("plantar_fascia", "Plantar fascia"),
      option("tendon_origin_insertion", "Tendon origin / insertion", true),
      option("ligament", "Ligament", true),
    ]),
    single("tenosynovitis", "Tenosynovitis", PRESENT_ABSENT_NOT_ASSESSED),
    single("tendon_appearance", "Tendon appearance", [
      option("normal", "Normal"),
      option("tendinopathy", "Tendinopathy"),
      option("partial_tear", "Partial tear"),
      option("not_assessed", "Not assessed"),
    ]),
    number("plantar_fascia_thickness", "Plantar fascia thickness", "mm", {
      min: 0,
      showWhen: { field: "site", in: ["plantar_fascia"] },
    }),
    number("median_nerve_csa", "Median nerve cross-sectional area", "mm²", {
      min: 0,
      showWhen: { field: "site", in: ["carpal_tunnel"] },
    }),
    single("doppler_signal", "Doppler signal", PRESENT_ABSENT_NOT_ASSESSED),
    APPROACH,
    NEEDLE_GAUGE,
    single(
      "needle_tip_visualized",
      "Needle tip visualized in target",
      YES_PARTIAL_NO,
    ),
    single("injectate_placement", "Injectate placement", [
      option("within_tendon_sheath", "Within tendon sheath"),
      option("peritendinous", "Peritendinous"),
      option("perifascial", "Perifascial"),
      option("perineural", "Perineural (carpal tunnel)"),
      OTHER_TEXT,
    ]),
    single(
      "intratendinous_injection_avoided",
      "Intratendinous / intraneural injection avoided",
      YES_NO,
    ),
    text("injectate", "Injectate (drug and dose)"),
    text("local_anesthetic", "Local anesthetic (drug and volume)"),
    number("total_volume_injected", "Total volume injected", "ml", { min: 0 }),
    routine(
      "immediate_complications",
      "Immediate complications",
      [
        option("none", "None"),
        option("vasovagal", "Vasovagal"),
        option("bleeding_hematoma", "Bleeding / hematoma"),
        option("paresthesia", "Paresthesia"),
        OTHER_TEXT,
      ],
      "none",
    ),
  ],
  siteFieldId: "site",
  needleTipFieldId: "needle_tip_visualized",
  completeWhenAnswered: [...SHARED_FIELD_IDS, "site", "needle_tip_visualized"],
  codesBySite: {
    flexor_tendon_sheath: ["20550", GUIDANCE],
    first_extensor_compartment: ["20550", GUIDANCE],
    other_tendon_sheath: ["20550", GUIDANCE],
    carpal_tunnel: ["20526", GUIDANCE],
    plantar_fascia: ["20550", GUIDANCE],
    tendon_origin_insertion: ["20551", GUIDANCE],
    ligament: ["20550", GUIDANCE],
  },
};
